import { useContext, useLayoutEffect } from "react";
import ProgressContext from "./progress";
import { LoaderOverlay } from "./BouncingDots";

/**
 * Loading state for pages and lazy boundaries. It holds the global ProgressContext overlay rather
 * than drawing its own, so a Suspense fallback, the step machine's own loads and the next page's
 * first fetch all share one continuous overlay instead of swapping between two loaders.
 * minHeight is accepted for older call sites and no longer used.
 */
// eslint-disable-next-line no-unused-vars
const PageLoader = ({ minHeight, text = "Loading..." }) => {
    const progress = useContext(ProgressContext);

    // Layout effect: the overlay is committed before this frame paints.
    useLayoutEffect(() => {
        if (!progress) return;
        progress.startLoading();
        return () => progress.finishLoading();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Only outside a ProgressContextProvider (not expected, index.js wraps the app).
    if (!progress) return <LoaderOverlay text={text} />;

    return null;
};

export default PageLoader;
